import ClickController  from "../click_controller";

export default class extends ClickController {
    static url = '/statistics/api/shoplink-click';
    static event = 'lead.shop-link';
}
